import { API_BASE_URL } from "../../Utils/apiConfig";

const loginUser = (username, password) => {
  return fetch(`${API_BASE_URL}/api/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username: username,
      password: password,
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Error en la solicitud');
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
};

export default loginUser;
